module.exports = __webpack_public_path__ + "img/side.127e34d9.svg";